import type { SxProps, Theme } from '@mui/material/styles';

import { Typography } from '@mui/material';

// ----------------------------------------------------------------------

export type FeatureBadgeProps = {
  /** Short stage text, e.g. "Preview" or "Coming soon". */
  label: string;
  sx?: SxProps<Theme>;
};

/** Small gradient overline text that marks the stage of a feature. */
export function FeatureBadge({ label, sx }: FeatureBadgeProps) {
  return (
    <Typography
      variant="overline"
      sx={[
        (theme) => ({
          fontSize: 10,
          letterSpacing: 0.5,
          fontWeight: theme.typography.fontWeightSemiBold,
          whiteSpace: 'nowrap',
          background: theme.gradients.primary.background,
          WebkitBackgroundClip: 'text',
          backgroundClip: 'text',
          color: 'transparent',
        }),
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {label}
    </Typography>
  );
}
